import script from "./OffersList.vue?vue&type=script&lang=ts&setup=true"
export * from "./OffersList.vue?vue&type=script&lang=ts&setup=true"

import "./OffersList.vue?vue&type=style&index=0&id=d7de53a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7de53a6"]])

export default __exports__